/* ============================================================
   ROSE VENOM ‚Äî LETTER BUILDER
   Category ‚Üí Template ‚Üí Personalize ‚Üí Add to Cart
   ============================================================ */

(function () {
  'use strict';

  /* ----------------------------------------------------------
     1. DATA ‚Äî Categories & Templates
     ---------------------------------------------------------- */
  var CATEGORIES = [
    {
      id: 'love',
      name: 'Love & Romance',
      tagline: 'For the one who has your whole heart',
      paper: '#FFF0F3',
      accent: '#C9526E',
      accentRgb: '201,82,110',
      templates: [
        {
          id: 'love-forever',
          name: 'Forever Yours',
          fields: [
            { key: 'Recipient Name', label: "Recipient's Name", placeholder: 'e.g. Sarah' },
            { key: 'Your Name',      label: 'Your Name',        placeholder: 'e.g. James' }
          ],
          body: 'My dearest {{Recipient Name}},\n\nThere are moments in life that redefine everything ‚Äî and meeting you was mine. Every day with you feels like a gift I never knew I deserved.\n\nI want you to know that my love for you is not something I can put into words, but I\'ll spend a lifetime trying. You are my home, my peace, and my greatest adventure.\n\nForever and always yours,\n{{Your Name}}'
        },
        {
          id: 'love-better',
          name: 'You Make Everything Better',
          fields: [
            { key: 'Recipient Name', label: "Recipient's Name", placeholder: 'e.g. Sarah' },
            { key: 'Your Name',      label: 'Your Name',        placeholder: 'e.g. James' }
          ],
          body: 'My love, {{Recipient Name}},\n\nI used to think I knew what happiness looked like. Then I met you, and I realized I had only seen shadows of it.\n\nYou make the ordinary extraordinary. A simple morning with you beats every highlight reel I\'ve ever imagined. Thank you for being exactly who you are ‚Äî because who you are is everything to me.\n\nWith all my heart,\n{{Your Name}}'
        },
        {
          id: 'love-just-because',
          name: 'Just Because',
          fields: [
            { key: 'Recipient Name', label: "Recipient's Name", placeholder: 'e.g. Sarah' },
            { key: 'Your Name',      label: 'Your Name',        placeholder: 'e.g. James' }
          ],
          body: '{{Recipient Name}},\n\nI don\'t need a special occasion to tell you this. I just need you to know.\n\nYou are the first thought I have when I wake up and the last one before I fall asleep. You are the reason I smile at my phone, lose track of time, and believe in something as unlikely as magic.\n\nI love you. Just because. Always because.\n\nYours,\n{{Your Name}}'
        },
        {
          id: 'love-our-story',
          name: 'Our Story',
          fields: [
            { key: 'Recipient Name', label: "Recipient's Name", placeholder: 'e.g. Sarah' },
            { key: 'How We Met',     label: 'How You Met',      placeholder: 'e.g. at that coffee shop on 5th' },
            { key: 'Your Name',      label: 'Your Name',        placeholder: 'e.g. James' }
          ],
          body: 'My darling {{Recipient Name}},\n\nEvery great love story starts somewhere. Ours started {{How We Met}}, and I wouldn\'t change a single chapter.\n\nThe world is better because we found each other in it. And I intend to spend every remaining page of this story showing you just how much you mean to me.\n\nHere\'s to us,\n{{Your Name}}'
        },
        {
          id: 'love-distance',
          name: 'Distance Means Nothing',
          fields: [
            { key: 'Recipient Name', label: "Recipient's Name", placeholder: 'e.g. Sarah' },
            { key: 'Your Name',      label: 'Your Name',        placeholder: 'e.g. James' }
          ],
          body: '{{Recipient Name}},\n\nNo matter how many miles or moments separate us, you are always with me. In the quiet hours, in the small joys, in the spaces between words ‚Äî I find you there.\n\nDistance has a way of reminding you what matters. And you matter more to me than anything.\n\nCounting down the moments until I see you again,\n{{Your Name}}'
        }
      ]
    },
    {
      id: 'apology',
      name: 'Apology',
      tagline: 'Because some things are worth saying out loud',
      paper: '#EEF4FF',
      accent: '#4A7EC7',
      accentRgb: '74,126,199',
      templates: [
        {
          id: 'apology-truly',
          name: "I'm Truly Sorry",
          fields: [
            { key: 'Recipient Name', label: "Recipient's Name", placeholder: 'e.g. Alex' },
            { key: 'Your Name',      label: 'Your Name',        placeholder: 'e.g. Jordan' }
          ],
          body: '{{Recipient Name}},\n\nI owe you more than this letter can hold, but I hope it\'s a start.\n\nI was wrong. What I did ‚Äî or didn\'t do ‚Äî hurt you, and you deserved better from me. I\'m not writing this to make excuses. I\'m writing it because I need you to know how deeply I regret what happened, and how much you mean to me.\n\nI\'m sorry. Truly, deeply, without condition.\n\n{{Your Name}}'
        },
        {
          id: 'apology-should-have',
          name: 'I Should Have Known Better',
          fields: [
            { key: 'Recipient Name', label: "Recipient's Name", placeholder: 'e.g. Alex' },
            { key: 'Your Name',      label: 'Your Name',        placeholder: 'e.g. Jordan' }
          ],
          body: '{{Recipient Name}},\n\nLooking back, I can see clearly what I couldn\'t see then ‚Äî how my actions affected you. I should have been more thoughtful. More present. More careful with your heart.\n\nI can\'t undo what happened, but I can promise you this: I hear you. I see you. And I will do better.\n\nWith humility and hope,\n{{Your Name}}'
        },
        {
          id: 'apology-deserve',
          name: 'You Deserve an Apology',
          fields: [
            { key: 'Recipient Name', label: "Recipient's Name", placeholder: 'e.g. Alex' },
            { key: 'Your Name',      label: 'Your Name',        placeholder: 'e.g. Jordan' }
          ],
          body: 'Dear {{Recipient Name}},\n\nYou have every right to be upset with me. I won\'t ask you to minimize what you felt or pretend it didn\'t matter, because it did ‚Äî and so do you.\n\nI am sorry for the hurt I caused. Not because I want things to go back to normal, but because you deserve to hear it clearly and without excuses.\n\nWhatever comes next, I\'m grateful for who you are.\n\nSincerely,\n{{Your Name}}'
        },
        {
          id: 'apology-make-right',
          name: 'Let Me Make It Right',
          fields: [
            { key: 'Recipient Name', label: "Recipient's Name", placeholder: 'e.g. Alex' },
            { key: 'Your Name',      label: 'Your Name',        placeholder: 'e.g. Jordan' }
          ],
          body: '{{Recipient Name}},\n\nI\'ve been sitting with the weight of what happened, and I realize the only thing heavier than my guilt is the thought of losing you.\n\nI\'m not just sorry ‚Äî I want to make it right. Tell me what you need. I\'m here, I\'m listening, and I\'m not going anywhere.\n\nWith all the sincerity I have,\n{{Your Name}}'
        },
        {
          id: 'apology-hurt-you',
          name: 'I Know I Hurt You',
          fields: [
            { key: 'Recipient Name', label: "Recipient's Name", placeholder: 'e.g. Alex'              },
            { key: 'What Happened',  label: 'What Happened',    placeholder: 'e.g. what I said last week' },
            { key: 'Your Name',      label: 'Your Name',        placeholder: 'e.g. Jordan'             }
          ],
          body: '{{Recipient Name}},\n\nI know {{What Happened}} hurt you more than I want to admit. And sitting with that knowledge has made one thing very clear to me.\n\nYou matter. Your feelings matter. And I never want to be the reason you feel otherwise again.\n\nI\'m sorry. Not because I have to say it ‚Äî because I mean it.\n\n{{Your Name}}'
        }
      ]
    },
    {
      id: 'missing',
      name: 'Missing You',
      tagline: 'For when the distance feels too real',
      paper: '#FFF8EE',
      accent: '#C47840',
      accentRgb: '196,120,64',
      templates: [
        {
          id: 'missing-every-day',
          name: 'Every Day Without You',
          fields: [
            { key: 'Recipient Name', label: "Recipient's Name", placeholder: 'e.g. Taylor' },
            { key: 'Your Name',      label: 'Your Name',        placeholder: 'e.g. Morgan' }
          ],
          body: '{{Recipient Name}},\n\nI didn\'t realize how much space you took up in my days until you weren\'t filling them anymore.\n\nI miss the sound of your laugh, the way you say my name, the effortless comfort of just being near you. The world keeps moving, but part of me is still standing wherever we last said goodbye.\n\nI hope you know ‚Äî you are missed. Completely.\n\n{{Your Name}}'
        },
        {
          id: 'missing-wishing',
          name: 'Wishing You Were Here',
          fields: [
            { key: 'Recipient Name', label: "Recipient's Name", placeholder: 'e.g. Taylor' },
            { key: 'Your Name',      label: 'Your Name',        placeholder: 'e.g. Morgan' }
          ],
          body: 'My dear {{Recipient Name}},\n\nI saw something today that made me think of you instantly. That\'s been happening more often than I can count.\n\nIt\'s strange how a person can be so far away and still be so present. You\'re in the songs that come on at the right moment, in the stories I save to tell you, in the quiet that follows a good day when I wish you were there to share it.\n\nCome back soon. Or let me come to you.\n\nAlways,\n{{Your Name}}'
        },
        {
          id: 'missing-counting',
          name: 'Counting Down',
          fields: [
            { key: 'Recipient Name', label: "Recipient's Name", placeholder: 'e.g. Taylor' },
            { key: 'Time Apart',     label: 'How Long Apart',   placeholder: 'e.g. three months' },
            { key: 'Your Name',      label: 'Your Name',        placeholder: 'e.g. Morgan' }
          ],
          body: '{{Recipient Name}},\n\nI\'ve started measuring time differently. Not in days or weeks, but in the distance between now and the next time I see you.\n\nIt turns out {{Time Apart}} is a very long time when you\'re used to having someone like you in your life. I\'ve tried to stay busy. It helps ‚Äî until it doesn\'t.\n\nNot much longer now. I\'m already looking forward to the moment we don\'t have to miss each other anymore.\n\nYours,\n{{Your Name}}'
        },
        {
          id: 'missing-always',
          name: "You're Always With Me",
          fields: [
            { key: 'Recipient Name', label: "Recipient's Name", placeholder: 'e.g. Taylor' },
            { key: 'Your Name',      label: 'Your Name',        placeholder: 'e.g. Morgan' }
          ],
          body: '{{Recipient Name}},\n\nThey say absence makes the heart grow fonder. I think absence just makes you honest about what was already there.\n\nI carry you with me everywhere. In my habits, in my humor, in the way I see things ‚Äî you\'ve shaped more of me than I realized. And I wouldn\'t take a bit of it back.\n\nMiss you more than words,\n{{Your Name}}'
        },
        {
          id: 'missing-memory',
          name: 'A Memory That Stays',
          fields: [
            { key: 'Recipient Name', label: "Recipient's Name", placeholder: 'e.g. Taylor' },
            { key: 'Shared Memory',  label: 'A Memory You Share', placeholder: 'e.g. that rainy afternoon in the city' },
            { key: 'Your Name',      label: 'Your Name',        placeholder: 'e.g. Morgan' }
          ],
          body: '{{Recipient Name}},\n\nI keep coming back to {{Shared Memory}}. It\'s one of those memories that gets more vivid the further away it gets.\n\nThat\'s you, I think. The further away you are, the more clearly I see what you mean to me.\n\nI don\'t have much more to say than this: I miss you. And I can\'t wait until I don\'t have to anymore.\n\n{{Your Name}}'
        }
      ]
    },
    {
      id: 'mothers',
      name: "Mother's Day",
      tagline: 'Celebrate the woman who made you who you are',
      paper: '#F5EFFF',
      accent: '#8956C5',
      accentRgb: '137,86,197',
      templates: [
        {
          id: 'mothers-thank-you',
          name: 'Thank You, Mom',
          fields: [
            { key: "Mom's Name", label: "Mom's Name",  placeholder: 'e.g. Mom, Mama, or her first name' },
            { key: 'Your Name',  label: 'Your Name',   placeholder: 'e.g. Emily' }
          ],
          body: "Dear {{Mom's Name}},\n\nThere isn't a card in the world long enough to hold what I want to say to you. So I'll start with this:\n\nThank you. For every early morning, every sacrifice you never mentioned, every time you put me first without asking for anything in return. For loving me before I even knew what love was, and for never stopping.\n\nI hope this Mother's Day gives you even a fraction of the joy you've given me.\n\nWith all the love I have,\n{{Your Name}}"
        },
        {
          id: 'mothers-things-you-did',
          name: 'The Things You Did',
          fields: [
            { key: "Mom's Name", label: "Mom's Name", placeholder: 'e.g. Mom, Mama, or her first name' },
            { key: 'Your Name',  label: 'Your Name',  placeholder: 'e.g. Emily' }
          ],
          body: "{{Mom's Name}},\n\nI've been thinking about all the things you did that I never thanked you for. The lunches packed, the tears wiped, the late nights waiting up, the quiet ways you showed up for me ‚Äî over and over and over again.\n\nI see it now. All of it. And I am so grateful.\n\nHappy Mother's Day to the woman who made me who I am.\n\nLove always,\n{{Your Name}}"
        },
        {
          id: 'mothers-inspiration',
          name: 'My Greatest Inspiration',
          fields: [
            { key: "Mom's Name",  label: "Mom's Name",          placeholder: 'e.g. Mom, Mama, or her first name' },
            { key: 'Child Name',  label: 'What She Calls You',  placeholder: 'e.g. daughter, son, kiddo'         },
            { key: 'Your Name',   label: 'Your Name',           placeholder: 'e.g. Emily'                        }
          ],
          body: "Dear {{Mom's Name}},\n\nYou never asked for credit. You never needed applause. You just kept showing up, working hard, loving deeply ‚Äî and somewhere along the way, that became my model for how to live.\n\nI didn't always say it out loud, but I've always known: you're the strongest person I know, and the most important one in my life.\n\nThank you for everything. Happy Mother's Day.\n\nYour {{Child Name}},\n{{Your Name}}"
        },
        {
          id: 'mothers-foundation',
          name: 'You Are My Foundation',
          fields: [
            { key: "Mom's Name", label: "Mom's Name", placeholder: 'e.g. Mom, Mama, or her first name' },
            { key: 'Your Name',  label: 'Your Name',  placeholder: 'e.g. Emily' }
          ],
          body: "{{Mom's Name}},\n\nI don't have the right words for what you mean to me. But today, I want to try.\n\nYou are warmth in the middle of hard days. You are the voice in my head that says I can. You are home ‚Äî not a place, but a feeling I carry with me everywhere I go.\n\nHappy Mother's Day. Thank you for being you.\n\nWith love beyond measure,\n{{Your Name}}"
        },
        {
          id: 'mothers-proud',
          name: 'Proud to Be Yours',
          fields: [
            { key: "Mom's Name", label: "Mom's Name", placeholder: 'e.g. Mom, Mama, or her first name' },
            { key: 'Your Name',  label: 'Your Name',  placeholder: 'e.g. Emily' }
          ],
          body: "Dear {{Mom's Name}},\n\nI've spent a lot of time becoming who I am. And the more I look at that person, the more I see you in them.\n\nYour kindness. Your patience. Your ability to find something to laugh about when things get hard. I got those from you. I hope I'm doing them justice.\n\nThank you for everything. I love you more than you know.\n\nHappy Mother's Day,\n{{Your Name}}"
        }
      ]
    }
  ];

  /* ----------------------------------------------------------
     2. STATE
     ---------------------------------------------------------- */
  /* ----------------------------------------------------------
     DELIVERY OPTIONS ‚Äî map to your Shopify variant IDs
     ---------------------------------------------------------- */
  var DELIVERY_OPTIONS = [
    {
      id:       '44886360817800',
      label:    'Standard',
      days:     '5-8 Business Days',
      price:    'Free',
      priceNum: 0
    },
    {
      id:       '44886360883336',
      label:    'Standard + Tracking',
      days:     '3-5 Business Days',
      price:    '$7',
      priceNum: 700
    },
    {
      id:       '44886360850568',
      label:    '2-Day Delivery',
      days:     '2 Business Days',
      price:    '$14',
      priceNum: 1400
    }
  ];

  var state = {
    step:             1,
    categoryId:       null,
    templateId:       null,
    fields:           {},
    editMode:         false,
    customBody:       null,
    date:             '',
    deliveryVariantId: DELIVERY_OPTIONS[0].id,
    senderName:        '',
    senderAddress:     '',
    fromHero:         false   // true when pre-filled via ?message= URL param
  };

  /* ----------------------------------------------------------
     3. HELPERS
     ---------------------------------------------------------- */
  function getCategory() {
    return CATEGORIES.find(function (c) { return c.id === state.categoryId; });
  }

  function getTemplate() {
    var cat = getCategory();
    return cat ? cat.templates.find(function (t) { return t.id === state.templateId; }) : null;
  }

  function todayFormatted() {
    var d = new Date();
    var months = ['January','February','March','April','May','June',
                  'July','August','September','October','November','December'];
    return months[d.getMonth()] + ' ' + d.getDate() + ', ' + d.getFullYear();
  }

  // Returns the letter body only ‚Äî no date prefix.
  // state.customBody always stores body-only text (no date).
  function compileBodyOnly() {
    if (state.customBody !== null) {
      // Hero flow: auto-wrap with "Dear Name," greeting and "Your Name" signature
      if (state.fromHero) {
        var recipName = (state.fields['Recipient Name'] || '').trim();
        var yourName  = (state.fields['Your Name']      || '').trim();
        var raw       = state.customBody.replace(/^\n+/, '');
        var parts     = [];
        if (recipName) parts.push('Dear ' + recipName + ',');
        parts.push(raw);
        if (yourName)  parts.push(yourName);
        return parts.join('\n\n');
      }
      // Template edit mode: strip any date prefix that crept in from older code
      if (state.date && state.date.trim()) {
        var datePfx = state.date.trim() + '\n\n';
        if (state.customBody.indexOf(datePfx) === 0) {
          return state.customBody.slice(datePfx.length);
        }
      }
      return state.customBody;
    }
    var tmpl = getTemplate();
    if (!tmpl) return '';
    var body = tmpl.body;
    Object.keys(state.fields).forEach(function (key) {
      var val = state.fields[key] || '';
      var re  = new RegExp('\\{\\{' + escapeRegex(key) + '\\}\\}', 'g');
      body    = body.replace(re, val || ('{{' + key + '}}'));
    });
    return body;
  }

  // Returns the full letter text for cart storage and modal preview (date + body).
  function compileLetter() {
    var body = compileBodyOnly();
    var date = state.date ? state.date.trim() : '';
    return date ? date + '\n\n' + body : body;
  }

  function escapeRegex(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function escapeHtml(str) {
    return str
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function setCSSVars(cat, el) {
    if (!cat || !el) return;
    el.style.setProperty('--cat-paper',      cat.paper);
    el.style.setProperty('--cat-accent',     cat.accent);
    el.style.setProperty('--cat-accent-rgb', cat.accentRgb);
  }

  /* ----------------------------------------------------------
     4. RENDER HELPERS
     ---------------------------------------------------------- */
  function renderProgress() {
    var labels = ['Choose Category', 'Select Template', 'Personalize'];
    var html   = '<div class="lb-progress">';
    labels.forEach(function (label, i) {
      var n   = i + 1;
      var cls = n < state.step ? 'is-done' : n === state.step ? 'is-active' : '';
      if (i > 0) html += '<div class="lb-progress-line"></div>';
      html += '<div class="lb-progress-step ' + cls + '">';
      html += '<div class="lb-progress-dot">' + (n < state.step ? '&#10003;' : n) + '</div>';
      html += '<span>' + label + '</span>';
      html += '</div>';
    });
    return html + '</div>';
  }

  function backBtn(step, label) {
    return '<button class="lb-back" data-action="go-step" data-step="' + step + '">'
      + '<svg viewBox="0 0 16 16" fill="none"><path d="M10 12L6 8L10 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>'
      + (label || 'Back')
      + '</button>';
  }

  /* ---- Step 1: Categories ---- */
  function renderCategories() {
    var html = '<div class="lb-step lb-step-categories">';
    html += '<div class="lb-heading"><h2>What would you like to say?</h2><p>Choose a category and we\'ll find the perfect words.</p></div>';
    html += '<div class="lb-categories">';

    CATEGORIES.forEach(function (cat) {
      html += '<button class="lb-category-card" data-action="select-category" data-id="' + cat.id + '"'
        + ' style="--cat-paper:' + cat.paper + ';--cat-accent:' + cat.accent + ';--cat-accent-rgb:' + cat.accentRgb + '">';

      // Envelope + paper illustration
      html += '<div class="lb-cat-showcase">' + envelopeSVG(cat) + '</div>';

      // Card footer
      html += '<div class="lb-cat-footer">';
      html += '<div><div class="lb-cat-name">' + escapeHtml(cat.name) + '</div>'
            + '<div class="lb-cat-desc">' + escapeHtml(cat.tagline) + '</div></div>';
      html += '<div class="lb-cat-arrow"><svg viewBox="0 0 14 14" fill="none"><path d="M2 7h10M8 3l4 4-4 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></div>';
      html += '</div>';

      html += '</button>';
    });

    html += '</div></div>';
    return html;
  }

  /* Envelope + letter SVG ‚Äî paper and accent colors come from the category */
  function envelopeSVG(cat) {
    var p  = cat.paper;   // paper fill
    var a  = cat.accent;  // accent for lines + seal
    return '<svg class="lb-env-svg" viewBox="0 0 200 160" fill="none" xmlns="http://www.w3.org/2000/svg">'

      // ‚îÄ‚îÄ Letter / paper peeking above envelope ‚îÄ‚îÄ
      + '<rect x="55" y="10" width="90" height="82" rx="4" fill="' + p + '"/>'

      // Ruled lines on the letter
      + '<line x1="70" y1="30" x2="130" y2="30" stroke="' + a + '" stroke-width="1.5" stroke-linecap="round" opacity="0.5"/>'
      + '<line x1="70" y1="43" x2="130" y2="43" stroke="' + a + '" stroke-width="1"   stroke-linecap="round" opacity="0.22"/>'
      + '<line x1="70" y1="56" x2="115" y2="56" stroke="' + a + '" stroke-width="1"   stroke-linecap="round" opacity="0.22"/>'
      + '<line x1="70" y1="69" x2="122" y2="69" stroke="' + a + '" stroke-width="1"   stroke-linecap="round" opacity="0.18"/>'

      // ‚îÄ‚îÄ Envelope body ‚îÄ‚îÄ
      + '<rect x="12" y="68" width="176" height="86" rx="5" fill="#1a1a26" stroke="rgba(255,255,255,0.07)" stroke-width="1.5"/>'

      // Bottom corner folds
      + '<path d="M12 154 L72 112" stroke="rgba(255,255,255,0.05)" stroke-width="1"/>'
      + '<path d="M188 154 L128 112" stroke="rgba(255,255,255,0.05)" stroke-width="1"/>'

      // ‚îÄ‚îÄ Envelope closed flap (V pointing down) ‚îÄ‚îÄ
      + '<path d="M12 68 L100 118 L188 68Z" fill="#21212e" stroke="rgba(255,255,255,0.06)" stroke-width="1"/>'

      // ‚îÄ‚îÄ Wax seal on flap ‚îÄ‚îÄ
      + '<circle cx="100" cy="102" r="12" fill="' + a + '" opacity="0.92"/>'
      + '<text x="100" y="107" text-anchor="middle" font-size="11" fill="white" font-family="serif" opacity="0.95">\u2726</text>'

    + '</svg>';
  }

  /* ---- Step 2: Templates ---- */
  function renderTemplates() {
    var cat = getCategory();
    if (!cat) return '';
    var html = '<div class="lb-step lb-step-templates">';
    html += backBtn(1, 'All categories');
    html += '<div class="lb-heading"><h2>' + escapeHtml(cat.name) + '</h2><p>Choose a letter to personalize</p></div>';
    html += '<div class="lb-templates">';
    cat.templates.forEach(function (tmpl) {
      var excerpt = tmpl.body.replace(/\{\{[^}]+\}\}/g, '___').split('\n').slice(0, 6).join('\n');
      html += '<button class="lb-template-card" data-action="select-template" data-id="' + tmpl.id + '">';
      html += '<div class="lb-template-paper"><div class="lb-template-excerpt">' + escapeHtml(excerpt) + '</div></div>';
      html += '<div class="lb-template-info">';
      html += '<div class="lb-template-name">' + escapeHtml(tmpl.name) + '</div>';
      html += '<div class="lb-template-meta">' + tmpl.fields.length + ' details to fill in</div>';
      html += '</div></button>';
    });
    html += '</div></div>';
    return html;
  }

  /* ---- Step 3: Personalize ---- */
  function renderPersonalize() {
    var cat  = getCategory();
    var tmpl = getTemplate();
    if (!cat || !tmpl) return '';

    var html = '<div class="lb-step lb-step-personalize">';
    if (!state.fromHero) {
      html += backBtn(2, 'Back to templates');
    }

    html += '<div class="lb-personalize">';

    /* --- Left: form --- */
    html += '<div class="lb-form-panel">';
    if (state.fromHero) {
      html += '<div class="lb-form-title">Finish your letter</div>';
      html += '<div class="lb-form-sub">Your message is ready &mdash; just fill in the details below.</div>';
    } else {
      html += '<div class="lb-form-title">Personalize your letter</div>';
      html += '<div class="lb-form-sub">' + escapeHtml(tmpl.name) + ' &middot; ' + escapeHtml(cat.name) + '</div>';
    }
    html += '<form id="lb-form" autocomplete="off">';

    // Date field ‚Äî always first
    html += '<div class="lb-field">';
    html += '<label for="lb-f-date">Date</label>';
    html += '<input type="text" id="lb-f-date" data-field="date" placeholder="e.g. April 15, 2026" value="' + escapeHtml(state.date) + '">';
    html += '</div>';

    if (state.fromHero) {
      // Hero flow: show minimal fields needed for the envelope & order printer
      var recipVal = escapeHtml(state.fields['Recipient Name'] || '');
      var yourVal  = escapeHtml(state.fields['Your Name'] || '');
      html += '<div class="lb-field">';
      html += '<label for="lb-f-Recipient-Name">Recipient\'s Name</label>';
      html += '<input type="text" id="lb-f-Recipient-Name" data-field="Recipient Name" placeholder="e.g. Sarah" value="' + recipVal + '">';
      html += '</div>';
      html += '<div class="lb-field">';
      html += '<label for="lb-f-Your-Name">Your Name</label>';
      html += '<input type="text" id="lb-f-Your-Name" data-field="Your Name" placeholder="e.g. James" value="' + yourVal + '">';
      html += '</div>';
    } else {
      // Template flow: render each template's placeholder fields
      tmpl.fields.forEach(function (f) {
        var fieldId = 'lb-f-' + f.key.replace(/[^a-zA-Z0-9]/g, '-');
        var val     = escapeHtml(state.fields[f.key] || '');
        html += '<div class="lb-field">';
        html += '<label for="' + fieldId + '">' + escapeHtml(f.label) + '</label>';
        html += '<input type="text" id="' + fieldId + '" data-field="' + escapeHtml(f.key) + '" placeholder="' + escapeHtml(f.placeholder) + '" value="' + val + '">';
        html += '</div>';
      });
    }

    /* --- Envelope sender details --- */
    html += '<div class="lb-sender-section">'
      + '<div class="lb-sender-header">'
      + '<svg class="lb-sender-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">'
      + '<rect x="2" y="5" width="20" height="14" rx="2"/>'
      + '<polyline points="2,5 12,13 22,5"/>'
      + '</svg>'
      + '<div class="lb-sender-header-text">'
      + '<span class="lb-sender-title">Your return address</span>'
      + '<span class="lb-sender-desc">Required ‚ printed on the envelope so your recipient knows who it\'s from.</span>'
      + '</div>'
      + '</div>'
      + '<div class="lb-sender-fields">'
      + '<div class="lb-sender-row">'
      + '<div class="lb-field lb-field--half">'
      + '<label for="lb-f-sender-name">Your name</label>'
      + '<input type="text" id="lb-f-sender-name" data-field="senderName" placeholder="e.g. James Carter" value="' + escapeHtml(state.senderName) + '">'
      + '</div>'
      + '</div>'
      + '<div class="lb-field">'
      + '<label for="lb-f-sender-address">Return address</label>'
      + '<textarea id="lb-f-sender-address" data-field="senderAddress" rows="3" placeholder="123 Main Street&#10;Apt 4B&#10;New York, NY 10001">' + escapeHtml(state.senderAddress) + '</textarea>'
      + '</div>'
      + '</div>'
      + '</div>';

    /* --- Inline preview (mobile only ‚Äî sits between sender and delivery) --- */
    var editIcon = state.editMode
      ? '<svg viewBox="0 0 14 14" fill="none"><path d="M10 2l2 2-7 7H3v-2l7-7z" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/><path d="M2 12h10" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/></svg>'
      : '<svg viewBox="0 0 14 14" fill="none"><path d="M10 2l2 2-7 7H3v-2l7-7z" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    var editToggleBtn = '<button type="button" class="lb-edit-toggle ' + (state.editMode ? 'is-active' : '') + '" data-action="toggle-edit">'
      + editIcon
      + (state.editMode ? 'Save changes' : 'Edit letter')
      + '</button>';

    html += '<div class="lb-preview-inline">';
    html += '<div class="lb-preview-label-row"><span class="lb-preview-label">' + (state.editMode ? 'Editing Letter' : 'Your Letter') + '</span>' + editToggleBtn + '</div>';
    if (state.editMode) {
      var editContentInline = compileBodyOnly();
      html += '<textarea class="lb-letter-edit" id="lb-letter-edit-inline" data-action="edit-body" spellcheck="true">'
        + escapeHtml(editContentInline)
        + '</textarea>';
      html += '<div class="lb-edit-hint">Edit freely. Tap "Save changes" when done.</div>';
    } else {
      html += '<div class="lb-letter" id="lb-letter-inline">' + buildLetterHTML() + '</div>';
    }
    html += '</div>';

    html += '<button type="button" class="lb-preview-btn" data-action="open-preview">'
          + '<svg viewBox="0 0 16 16" fill="none"><ellipse cx="8" cy="8" rx="7" ry="5" stroke="currentColor" stroke-width="1.4"/><circle cx="8" cy="8" r="2" fill="currentColor"/></svg>'
          + 'Preview on paper \u2713'
          + '</button>';

    html += '<div class="lb-delivery">';
    html += '<div class="lb-delivery-label">Delivery</div>';
    DELIVERY_OPTIONS.forEach(function (opt) {
      var active = state.deliveryVariantId === opt.id;
      html += '<button type="button" class="lb-delivery-opt' + (active ? ' is-active' : '') + '" data-action="select-delivery" data-id="' + opt.id + '">';
      html += '<span class="lb-delivery-name">' + opt.label + '</span>';
      html += '<span class="lb-delivery-days">' + opt.days + '</span>';
      html += '<span class="lb-delivery-price">' + opt.price + '</span>';
      html += '</button>';
    });
    html += '</div>';

    html += '<button type="button" class="lb-add-to-cart" data-action="add-to-cart">Add to Cart</button>';
    html += '</form></div>';

    /* --- Right: live preview or editable textarea --- */
    html += '<div class="lb-preview-panel">';
    html += '<div class="lb-preview-label-row"><span class="lb-preview-label">' + (state.editMode ? 'Editing Letter' : 'Live Preview') + '</span>' + editToggleBtn + '</div>';

    if (state.editMode) {
      var editContent = compileBodyOnly();
      html += '<textarea class="lb-letter-edit" id="lb-letter-edit" data-action="edit-body" spellcheck="true">'
        + escapeHtml(editContent)
        + '</textarea>';
      html += '<div class="lb-edit-hint">Edit freely. Click "Save changes" when done.</div>';
    } else {
      html += '<div class="lb-letter" id="lb-letter">' + buildLetterHTML() + '</div>';
    }

    html += '</div>';

    html += '</div></div>';
    return html;
  }

  /* Build the letter HTML with placeholder highlights */
  function buildLetterHTML() {
    var tmpl = getTemplate();
    if (!tmpl) return '';

    var html = '';

    // Date ‚Äî right-aligned, top of letter
    if (state.date && state.date.trim()) {
      html += '<div class="lb-letter-date">' + escapeHtml(state.date.trim()) + '</div>';
    }

    // If user has freely edited (or came from hero), use compileBodyOnly()
    // which handles greeting/signature assembly for fromHero, and date-stripping for edit mode
    if (state.customBody !== null) {
      var assembled = compileBodyOnly();
      var safe = escapeHtml(assembled).replace(/\n/g, '<br>');
      return html + safe;
    }

    var safe = escapeHtml(tmpl.body);

    // Replace {{Key}} with highlighted spans
    safe = safe.replace(/\{\{([^}]+)\}\}/g, function (match, key) {
      var val    = state.fields[key];
      var filled = val && val.trim();
      var cls    = filled ? 'lb-ph is-filled' : 'lb-ph';
      return '<span class="' + cls + '">' + (filled ? escapeHtml(val) : escapeHtml(key)) + '</span>';
    });

    safe = safe.replace(/\n/g, '<br>');
    return html + safe;
  }

  /* ----------------------------------------------------------
     5. MAIN RENDER
     ---------------------------------------------------------- */
  var wrap;

  function render() {
    if (!wrap) return;
    var html = renderProgress();
    if (state.step === 1) html += renderCategories();
    if (state.step === 2) html += renderTemplates();
    if (state.step === 3) html += renderPersonalize();
    wrap.innerHTML = html;

    var cat = getCategory();
    if (cat) setCSSVars(cat, wrap);

    if (state.step === 3) focusFirstField();
  }

  function focusFirstField() {
    var first = wrap.querySelector('.lb-field input:not([data-field="date"])');
    if (first && !first.value) first.focus();
  }

  /* ----------------------------------------------------------
     6. EVENTS  ‚Äî bound ONCE at init, never removed
     ---------------------------------------------------------- */

  function handleClick(e) {
    var el     = e.target;
    var btn    = el.closest ? el.closest('[data-action]') : null;
    if (!btn) return;

    var action = btn.getAttribute('data-action');

    if (action === 'select-category') {
      state.categoryId = btn.getAttribute('data-id');
      state.templateId = null;
      state.fields     = {};
      state.step       = 2;
      render();
      scrollToTop();
    }

    if (action === 'select-template') {
      state.templateId = btn.getAttribute('data-id');
      state.fields     = {};
      state.editMode   = false;
      state.customBody = null;
      state.step       = 3;
      render();
      scrollToTop();
    }

    if (action === 'go-step') {
      var dest = parseInt(btn.getAttribute('data-step'), 10);
      if (dest === 1) { state.categoryId = null; state.templateId = null; state.fields = {}; }
      if (dest === 2) { state.templateId = null; state.fields = {}; }
      state.editMode   = false;
      state.customBody = null;
      state.step       = dest;
      render();
      scrollToTop();
    }

    if (action === 'toggle-edit') {
      if (!state.editMode) {
        // Only seed from template if user hasn't already made custom edits
        if (state.customBody === null) {
          var tmpl2 = getTemplate();
          if (tmpl2) {
            var body2 = tmpl2.body;
            Object.keys(state.fields).forEach(function (k) {
              body2 = body2.replace(new RegExp('\\{\\{' + escapeRegex(k) + '\\}\\}', 'g'), state.fields[k] || ('{{' + k + '}}'));
            });
            state.customBody = body2;
          } else {
            state.customBody = '';
          }
        }
        // If customBody already exists, re-open textarea with their existing edits intact
        state.editMode = true;
        render();
        // Scroll to textarea and focus it so user lands right on the editable text
        var ta = document.getElementById('lb-letter-edit') || document.getElementById('lb-letter-edit-inline');
        if (ta) {
          setTimeout(function () {
            ta.scrollIntoView({ behavior: 'smooth', block: 'center' });
            ta.focus();
          }, 50);
        }
      } else {
        // Read from whichever textarea is visible ‚Äî inline (mobile) takes priority
        var ta = document.getElementById('lb-letter-edit-inline') || document.getElementById('lb-letter-edit');
        if (ta) state.customBody = ta.value;
        state.editMode = false;
        render();
      }
    }


    if (action === 'add-to-cart') {
      closePreviewModal();
      handleAddToCart();
    }

    if (action === 'select-delivery') {
      state.deliveryVariantId = btn.getAttribute('data-id');
      // Update active class without full re-render
      wrap.querySelectorAll('.lb-delivery-opt').forEach(function (b) {
        b.classList.toggle('is-active', b.getAttribute('data-id') === state.deliveryVariantId);
      });
    }

    if (action === 'open-preview') {
      // Sync textarea content first so preview always shows latest typed text
      if (state.editMode) {
        var taPrev = document.getElementById('lb-letter-edit') || document.getElementById('lb-letter-edit-inline');
        if (taPrev) state.customBody = taPrev.value;
      }
      openPreviewModal();
    }

    if (action === 'close-preview') {
      closePreviewModal();
    }

    if (action === 'restart') {
      state = { step: 1, categoryId: null, templateId: null, fields: {}, editMode: false, customBody: null, date: '', deliveryVariantId: DELIVERY_OPTIONS[0].id, senderName: '', senderAddress: '', fromHero: false };
      render();
      scrollToTop();
    }
  }

  function handleInput(e) {
    var input = e.target;
    if (!input) return;

    // Free-text edit textarea ‚Äî no re-render needed, textarea is live
    if (input.getAttribute('data-action') === 'edit-body') {
      state.customBody = input.value;
      state.fromHero   = false; // user now owns the full text ‚Äî don't auto-wrap
      return;
    }

    if (!input.hasAttribute('data-field')) return;
    var key = input.getAttribute('data-field');

    // Date field
    if (key === 'date') {
      state.date = input.value;
      refreshLetterPreview();
      return;
    }

    // Sender details ‚Äî stored separately, not in template fields
    if (key === 'senderName') { state.senderName = input.value; return; }
    if (key === 'senderAddress') { state.senderAddress = input.value; return; }

    // Placeholder fields
    state.fields[key] = input.value;
    input.classList.remove('lb-error');
    refreshLetterPreview();
  }

  function handleKeydown(e) {
    // Allow Enter in inputs to move to the next field
    if (e.key === 'Enter' && e.target.tagName === 'INPUT') {
      e.preventDefault();
      var inputs  = Array.prototype.slice.call(wrap.querySelectorAll('.lb-field input'));
      var current = inputs.indexOf(e.target);
      if (current >= 0 && current < inputs.length - 1) {
        inputs[current + 1].focus();
      }
    }
  }

  function refreshLetterPreview() {
    var html = buildLetterHTML();
    var letter = document.getElementById('lb-letter');
    if (letter) letter.innerHTML = html;
    var letterInline = document.getElementById('lb-letter-inline');
    if (letterInline) letterInline.innerHTML = html;
  }

  function scrollToTop() {
    if (wrap.scrollIntoView) wrap.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  /* ----------------------------------------------------------
     7. ADD TO CART
     ---------------------------------------------------------- */
  function handleAddToCart() {
    var tmpl = getTemplate();
    var cat  = getCategory();
    if (!tmpl || !cat) return;

    // Validate name fields
    if (state.fromHero) {
      // Hero flow ‚Äî validate the two explicit fields
      var heroFieldKeys = ['Recipient Name', 'Your Name'];
      var heroErrors = heroFieldKeys.filter(function (k) {
        return !state.fields[k] || !state.fields[k].trim();
      });
      if (heroErrors.length) {
        heroErrors.forEach(function (k) {
          var input = wrap.querySelector('[data-field="' + k + '"]');
          if (input) {
            input.classList.add('lb-error');
            input.addEventListener('input', function () { this.classList.remove('lb-error'); }, { once: true });
          }
        });
        var firstHeroErr = wrap.querySelector('.lb-error');
        if (firstHeroErr) { firstHeroErr.scrollIntoView({ behavior: 'smooth', block: 'center' }); firstHeroErr.focus(); }
        return;
      }
    } else {
      // Template flow ‚Äî validate each template's placeholder fields
      var emptyFields = tmpl.fields.filter(function (f) {
        return !state.fields[f.key] || !state.fields[f.key].trim();
      });
      if (emptyFields.length) {
        emptyFields.forEach(function (f) {
          var input = wrap.querySelector('[data-field="' + f.key + '"]');
          if (input) {
            input.classList.add('lb-error');
            input.addEventListener('input', function () { this.classList.remove('lb-error'); }, { once: true });
          }
        });
        var first = wrap.querySelector('.lb-error');
        if (first) first.focus();
        return;
      }
    }

    // Validate sender details (required)
    var senderErrors = [];
    if (!state.senderName || !state.senderName.trim()) senderErrors.push('lb-f-sender-name');
    if (!state.senderAddress || !state.senderAddress.trim()) senderErrors.push('lb-f-sender-address');
    if (senderErrors.length) {
      senderErrors.forEach(function (id) {
        var el = wrap.querySelector('#' + id);
        if (el) {
          el.classList.add('lb-error');
          el.addEventListener('input', function () { this.classList.remove('lb-error'); }, { once: true });
        }
      });
      var firstSenderErr = wrap.querySelector('#' + senderErrors[0]);
      if (firstSenderErr) {
        firstSenderErr.scrollIntoView({ behavior: 'smooth', block: 'center' });
        firstSenderErr.focus();
      }
      return;
    }

    var letter = compileBodyOnly(); // body only ‚Äî date sent separately as 'Date' property

    // Use the selected delivery variant ID
    var variantId = parseInt(state.deliveryVariantId, 10);

    if (!variantId) {
      console.error('[Letter Builder] No delivery option selected.');
      alert('Please select a delivery option and try again.');
      return;
    }

    var cartBtn = wrap.querySelector('[data-action="add-to-cart"]');
    if (cartBtn) { cartBtn.disabled = true; cartBtn.textContent = 'Adding to cart‚Ä¶'; }

    var selectedDelivery = DELIVERY_OPTIONS.find(function (o) { return o.id === state.deliveryVariantId; });

    var properties = {
      'Category':    cat.name,
      'Template':    tmpl.name,
      'Paper Color': cat.paper,
      'Delivery':    selectedDelivery ? selectedDelivery.label + ' (' + selectedDelivery.days + ')' : '',
      'Date':        state.date || todayFormatted(),
      'Letter':      letter,
      // Envelope sender details (names match Order Printer envelope template)
      'Envelope Sender Full Name': state.senderName || '',
      'Envelope Return Address':   state.senderAddress || ''
    };
    tmpl.fields.forEach(function (f) {
      properties[f.label] = state.fields[f.key] || '';
    });

    fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ id: variantId, quantity: 1, properties: properties })
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data.status && data.status !== 200) {
          if (cartBtn) { cartBtn.disabled = false; cartBtn.textContent = 'Add to Cart'; }
          alert(data.description || 'Could not add to cart. Please try again.');
        } else {
          renderSuccessState();
        }
      })
      .catch(function (err) {
        console.error('[Letter Builder] Cart error:', err);
        if (cartBtn) { cartBtn.disabled = false; cartBtn.textContent = 'Add to Cart'; }
        alert('Something went wrong. Please try again.');
      });
  }

  /* ----------------------------------------------------------
     8. SUCCESS STATE
     ---------------------------------------------------------- */
  function renderSuccessState() {
    var cat = getCategory();
    wrap.innerHTML =
      '<div class="lb-success">'
      + '<div class="lb-success-check">&#10003;</div>'
      + '<h3>Letter added to your cart</h3>'
      + '<p>Your personalized letter is saved and ready.<br>We\'ll print it on ' + escapeHtml(cat ? cat.name : '') + ' paper.</p>'
      + '<div class="lb-success-actions">'
      + '<a href="/cart" class="lb-btn-primary">View Cart</a>'
      + '<button data-action="restart" class="lb-btn-secondary">Write Another Letter</button>'
      + '</div>'
      + '</div>';
    // No listener needed ‚Äî persistent listener on wrap handles restart click
  }

  /* ----------------------------------------------------------
     9. PAPER PREVIEW MODAL  (8.5 √ó 11)
     ---------------------------------------------------------- */
  function openPreviewModal() {
    closePreviewModal();
    var cat      = getCategory();
    // Use compileBodyOnly + state.date directly ‚Äî never parse compileLetter output
    var dateLine = state.date ? state.date.trim() : '';
    var body = compileBodyOnly();
    // Strip today's date wherever it appears in the body (legacy from old code)
    if (dateLine) {
      var safeDate = dateLine.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      body = body.replace(new RegExp(safeDate + '[ \\t]*\\n*', 'g'), '');
    }
    // Also strip any generic "Month D(D), YYYY" pattern at start of body
    body = body.replace(/^[A-Za-z]+ \d{1,2}, \d{4}[ \t]*\n*/, '');
    // Trim any leading blank lines left after stripping
    body = body.replace(/^\n+/, '');
    var bodyHtml = escapeHtml(body).replace(/\n/g, '<br>');

    var modal = document.createElement('div');
    modal.id  = 'lb-preview-modal';
    modal.className = 'lb-paper-modal';
    if (cat) {
      modal.style.setProperty('--cat-paper',      cat.paper);
      modal.style.setProperty('--cat-accent',     cat.accent);
      modal.style.setProperty('--cat-accent-rgb', cat.accentRgb);
    }

    modal.innerHTML =
      '<div class="lb-paper-modal-inner">'
      + '<div class="lb-paper-modal-header">'
      + '<span class="lb-paper-modal-label">Letter Preview &mdash; 8.5 &times; 11"</span>'
      + '<button type="button" class="lb-paper-close" data-action="close-preview">'
      +   '<svg viewBox="0 0 14 14" fill="none"><path d="M2 2l10 10M12 2L2 12" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>'
      +   'Close'
      + '</button>'
      + '</div>'
      + '<div class="lb-paper-sheet">'
      +   (dateLine ? '<div class="lb-paper-date">' + escapeHtml(dateLine) + '</div>' : '')
      +   '<div class="lb-paper-body">' + bodyHtml + '</div>'
      + '</div>'
      + '<div class="lb-paper-actions">'
      +   '<button type="button" class="lb-btn-secondary" data-action="close-preview">Edit more</button>'
      +   '<button type="button" class="lb-add-to-cart lb-cart-modal-btn" data-action="add-to-cart">Add to Cart</button>'
      + '</div>'
      + '</div>';

    // Append to document.body so the modal sits above all page content
    document.body.appendChild(modal);
    document.body.style.overflow = 'hidden';

    // Handle all clicks inside the modal (buttons + backdrop)
    modal.addEventListener('click', function (e) {
      if (e.target === modal) { closePreviewModal(); return; }
      var btn = e.target.closest('[data-action]');
      if (!btn) return;
      var action = btn.getAttribute('data-action');
      if (action === 'close-preview') { closePreviewModal(); return; }
      if (action === 'add-to-cart') { closePreviewModal(); handleAddToCart(); return; }
    });
  }

  function closePreviewModal() {
    var modal = document.getElementById('lb-preview-modal');
    if (modal) modal.remove();
    document.body.style.overflow = '';
  }

  /* ----------------------------------------------------------
     10. INIT
     ---------------------------------------------------------- */
  function init() {
    wrap = document.querySelector('.lb-wrap');
    if (!wrap) return;

    // Pre-fill today's date
    state.date = todayFormatted();

    // ‚îÄ‚îÄ ?message= deep-link from hero section ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ
    // If the URL has ?message=, skip category+template selection
    // and land straight on the compose step with the user's text.
    var urlParams = new URLSearchParams(window.location.search);
    var urlMessage = urlParams.get('message');
    if (urlMessage && urlMessage.trim()) {
      // Default to first category + template so the rest of the
      // UI has valid state (fields, paper colour, etc.)
      state.categoryId  = CATEGORIES[0].id;
      state.templateId  = CATEGORIES[0].templates[0].id;
      state.customBody  = urlMessage.trim();
      state.step        = 3;
      state.fromHero    = true;
    }
    // ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ‚îÄ

    // Bind ALL events ONCE ‚Äî permanent delegation, no re-binding on render
    wrap.addEventListener('click',   handleClick);
    wrap.addEventListener('input',   handleInput);
    wrap.addEventListener('keydown', handleKeydown);

    render();
  }

  // Boot
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
